import React from "react";
import { Container } from "react-bootstrap";

import "../../css/HeroHeader.scss";
import "./PEDHeroHeader.scss";

export default function ITPHeroHeader(props) {
  const desktopImg = props.bgImage[0];
  const desktopRetinaImg = props.bgImage[1];
  const mobileImg = props.bgImageMobile[0];
  const mobileRetinaImg = props.bgImageMobile[1];
  const imageAlt = props.imageAlt;
  let css = `
    .hero_header {
      background-image: image-set(
        url(${desktopImg}) 1x,
        url(${desktopRetinaImg}) 2x
      );
    }
    @media screen and (max-width: 991px) {
      .hero_header {
        background-image: image-set(
          url(${mobileImg}) 1x,
          url(${mobileRetinaImg}) 2x
        );
      }
    }
  `;
  if (!props.textSitsOnImageForMobile) {
    css += `
      @media screen and (max-width: 991px) {
        .hero_header {
          background-image: none !important;
        }
        .hero_header_inner {
          padding-top: 0;
        }
      }
    `;
  } else {
    css += `
      @media screen and (max-width: 991px) {
        .hero_header_inner {
          background: transparent !important;
          color: white;
          min-height: 650px;
        }
      }
    `;
  }
  return (
    <React.Fragment>
      <div className={`hero_header ped_hero_header ${props.extraClass}`}>
        <style>{css}</style>
        <Container>
          <div
            className="hero_header_inner"
            style={{
              maxWidth: props.maxWidth ? props.maxWidth + "px" : "",
            }}
          >
            {props.markup}
          </div>
        </Container>
        {props.textSitsOnImageForMobile ? (
          ""
        ) : (
          <div className="hero-img-mobile d-lg-none">
            <picture>
              <source srcSet={mobileImg + " 1x, " + mobileRetinaImg + " 2x"} />
              <img
                src={mobileRetinaImg}
                className="img-responsive"
                alt={imageAlt}
              />
            </picture>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
